import React, { useState, useEffect } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import "./Unit.css"
import SweetAlert from "react-bootstrap-sweetalert"
import { Link } from "react-router-dom"
import { usePermissions } from "API/PermissionContext"

const MaterialUnitTypes = props => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.CONFIGURATIONS
  const user = localStorage.getItem("authUser")
  const userInfo = JSON.parse(user)
  const [units, setUnits] = useState([])
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [unitId, setUnitId] = useState([])
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [cell, setCell] = useState("")
  const [search, setSearch] = useState({ unitType:'',decimal:''})
  const [checkedItems, setCheckedItems] = useState([])
  const [parentChecked, setParentChecked] = useState(false)
  const [load, setLoad] = useState(false)
  const [showFilter, setShowFilter] = useState(false)

  useEffect(() => { fetchData() }, [load])
  useEffect(() => {
    setCheckedItems(new Array(units.length).fill(false))
    setParentChecked(false)
  }, [units.length])

  const fetchData = async () => {
    try {
      const response = await api.get("units-user/" + userInfo.uid)
      setUnits(Array.isArray(response.data.data) ? response.data.data : response.data.data?.data || [])
    } catch (error) { console.error("Failed to fetch data:", error) }
  }
  const fetchDelete = async () => {
    try {
      const deleteUnit = await api.delete("delete-unit/" + unitId)
      if (deleteUnit.data.success === true) setLoad(!load)
    } catch (error) { console.error("Failed to delete:", error) }
  }
  const handleCheckboxChange = (i) => {
    const newCheckedItems = [...checkedItems]
    newCheckedItems[i] = !newCheckedItems[i]
    setCheckedItems(newCheckedItems)
    setParentChecked(newCheckedItems.every((item) => item))
  }
  const handleParentCheckboxChange = () => {
    const newParentChecked = !parentChecked
    setParentChecked(newParentChecked)
    setCheckedItems(new Array(units.length).fill(newParentChecked))
  }
  const getSelectedUnitIds = async () => {
    const selectedIds = units.map((unit, i) => (checkedItems[i] ? unit.id : null)).filter(id => id !== null)
    const r = await api.post("delete-multiple-unit", { items: selectedIds })
    if (r.data.success === true) setLoad(!load)
  }
  const removeFilter = () => {
    setSearch({ unitType:'',decimal:''})
    setShowFilter(!showFilter)
  }

  return (
    <>
      <div className="dashBody">
        {canDelete(MID) && (
          <button className="delete-button" onClick={() => setconfirm_multiple_alert(true)}>
            <i className="fa fa-trash"></i>
          </button>
        )}
        <button className="filter_rel btn btn-primary" onClick={() => removeFilter()}>
          <i className="fa fa-filter"></i>
          {showFilter && <i className="rel_filter_ban fa fa-ban"></i>}
        </button>
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Material Unit Types</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              {canAdd(MID) && (
                <Link className="dashBtn" to="/add-material-unit">
                  <i className="fas fa-plus-square "></i> <b> Add New</b>
                </Link>
              )}
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="unitTypes">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckboxChange} /></th>
                <th>S.No</th>
                <th>Material Unit Type Name</th>
                <th>Allow Decimal</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  <td><input type="text" className="form-control material_unit_type_sub"
                    onChange={e => setSearch({...search, unitType: e.target.value})}
                    value={search.unitType} placeholder="Material Unit Type Name" /></td>
                  <td><select className="form-control" onChange={(e) => setSearch({...search, decimal:e.target.value})}>
                    <option value="">Select</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select></td>
                  <td><a className="btn btn-block btn-success applyFilter" title="Apply Filter"><i className="fa fa-search"></i> Apply</a></td>
                </tr>
              )}
              {units.length > 0 ? (
                units.filter(item =>
                  (item.unitName || "").toLowerCase().includes(search.unitType.toLowerCase()) &&
                  (item.allowDecimal || "").toLowerCase().includes(search.decimal.toLowerCase())
                ).map((unit, i) => (
                  <tr key={i}>
                    <td><input type="checkbox" checked={checkedItems[i]} onChange={() => handleCheckboxChange(i)} /></td>
                    <td>{i + 1}</td>
                    <td>{unit.unitName}</td>
                    <td>{unit.allowDecimal === "1" ? "Yes" : "No"}</td>
                    <td>
                      {canEdit(MID) && <Link to={"/edit-material-unit/" + unit.id}><i className="fas fa-edit icons icon-edit"></i></Link>}
                      {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete"
                        onClick={() => { setUnitId(unit.id); setCell(i + 1); setconfirm_alert(true) }} id="sa-success"></i>}
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={5}><p>No Records Found!</p></td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { fetchDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Unit type deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { getSelectedUnitIds(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Unit types deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default MaterialUnitTypes
